import React from 'react';
import ThriveModal from './ThriveModal';
import MediaInfo from '../information/media/MediaInfo';



const  MediaModal = ({className, profileImageUrl, userDisplayName, mediaTitle, mediaUploadDate, mediaContent, onCloseClick}:{className?: string, profileImageUrl: string, userDisplayName: string, mediaTitle: string, mediaUploadDate: string, mediaContent: any, onCloseClick: ()=>void}) => {
    return (
        <ThriveModal 
            showModal
            className={`media-modal ${className}`}
            headerContent={<MediaInfo profileImageUrl={profileImageUrl} displayName={userDisplayName} mediaTitle={mediaTitle} date={mediaUploadDate} />} 
            bodyContent={mediaContent} 
            footerContent={undefined} 
            onCloseClick={onCloseClick}
        />
    );
};

export default MediaModal;